import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { VaIconModule } from '@vendasta/uikit';
import baseTranslation from '../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../shared/constants';
import { ProductsNavV2Component } from './products-nav-v2/products-nav-v2.component';
import { VaProductsNavComponent } from './products-nav.component';
import { ProductTypePipe } from './productType.pipe';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    VaIconModule,
    GalaxyBadgeModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    ProductTypePipe,
  ],
  declarations: [VaProductsNavComponent, ProductsNavV2Component],
  exports: [VaProductsNavComponent, ProductsNavV2Component],
})
export class VaProductsNavModule {}
